export default __webpack_public_path__ + "static/media/VFC_Jahresbericht_2013.7ba639ef.pdf";